import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

import { PickerOptions } from "@ionic/core";

import { NewPageSelectComponent } from '../../new-page-select/new-page-select.component';
import { LazyLoadingSelectComponent } from '../../lazy-loading-select/lazy-loading-select.component';
import { TranslateService } from '@ngx-translate/core';
import { CorpSelectComponent } from '../../corp-select/corp-select.component';
import { OrgCascaderComponent } from '../../org-cascader/org-cascader.component';
@Component({
	selector: 'contractor-filter-modal',
	templateUrl: './contractor-filter-modal.component.html',
	styleUrls: ['./contractor-filter-modal.component.scss'],
})
export class ContractorFilterModalComponent implements OnInit {
  query;
	// 默认筛选条件
  startTime = null;
  endTime = null;
  currentDateString = new Date().toISOString();

  isCompany;
  isEmployee;
  isContractorCompanyMultiSelect;
  isContractorEmployeeMultiSelect;
  isContractorProjectMultiSelect;
  isContractorWorkMultiSelect;
  isProject;
  isWork;
  isEval;
  isSupportDoc;

  taskStatusList = [];
  workRiskLevelList = [];
  occupationList = [];
  contractorStatusList = [];
  employeeStatusList = [];
  contractorCompanyList = [];
  projectStatusList = [];
  projectList = [];
  locationsList = [];
  workStatusList = [];
  evalStatusList = [];
  reviewList = [];
  
  isContractor: boolean = this.localStorageService.getStore('partyEmployee') === 'true' ? true : false; // 是否是相关方
	constructor(
		public dataService: DataService,
		public appService: AppService,
		public router: Router,
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalController: ModalController,
    public localStorageService: LocalStorageService,
    public pickerController: PickerController,
    private translateService: TranslateService,
  ) {
		let params = this.navParams.data;
    this.query = params.query;
    this.isCompany = params.isCompany;
    this.isEmployee = params.isEmployee;
    this.isContractorCompanyMultiSelect = params.isContractorCompanyMultiSelect;
    this.isContractorEmployeeMultiSelect = params.isContractorEmployeeMultiSelect;
    this.isContractorProjectMultiSelect = params.isContractorProjectMultiSelect;
    this.isContractorWorkMultiSelect = params.isContractorWorkMultiSelect;
    this.isProject = params.isProject;
    this.isWork = params.isWork;
    this.isEval = params.isEval;
    this.isSupportDoc = params.isSupportDoc;
	}

	ngOnInit() {
		// 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
    // 获取状态code
    if (this.isCompany) {
      this.getRiskLevelList(); // 获取工作风险等级
      this.getContractorStatusList(); // 获取承包商状态
    } else if (this.isEmployee) {
      this.getContractorCompanyList(); // 承包商公司列表
      this.getOccupationList(); // 获取职业/工种
      this.getEmployeeStatusList(); // 获取承包商人员状态
    } else if (this.isProject) {
      this.getContractorCompanyList(); // 承包商公司列表
      this.getProjectStatusList(); // 获取项目状态
    } else if (this.isWork) {
      this.getContractorCompanyList(); // 承包商公司列表
      this.getProjectList(); // 获取项目列表
      this.getLocationsList(); // 获取地点列表
      this.getWorkStatusList(); // 获取作业状态
    } else if (this.isEval) {
      this.getReviewList(); // 获取评级
      this.getEvalStatusList(); // 获取评估状态
    }
	}

  // 获取风险等级code
  async getRiskLevelList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_RATE_R2').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.workRiskLevelList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取职业工种
  async getOccupationList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_OCCUPATION').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.occupationList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取承包商公司列表
  async getContractorCompanyList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSupplierList().subscribe(res => {
        if (res && res.STATUS === 0) {
          this.contractorCompanyList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取承包商状态
  async getContractorStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_STATUS_S1').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.contractorStatusList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取承包商人员状态
  async getEmployeeStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_A9_PARTY').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.employeeStatusList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取项目状态
  async getProjectStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_A9_PROJECT').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.projectStatusList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取承包商作业状态
  async getWorkStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_JOB_status').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.workStatusList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取评估状态
  async getEvalStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_EV').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.evalStatusList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取项目评级列表
  async getReviewList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_EVA_R').subscribe(res => {
        if (res && res.STATUS === 0) {
          this.reviewList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取项目列表
  async getProjectList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getProjectListOfAll().subscribe(res => {
        if (res && res.STATUS === 0) {
          this.projectList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取地点列表
  async getLocationsList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSpaceOfOrgId().subscribe(res => {
        if (res && res.STATUS === 0) {
          this.locationsList = res.DATA;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

	// 重置条件
	resetSearchFilters() {
    Object.keys(this.query).forEach((item, index) => {
      this.query[item] = null;
    });
	}

	cancel() {
		this.modalController.dismiss();
	}

	confirm() {
		this.modalController.dismiss({ query: this.query });
  }
  
  // ==================================Method===========================================

  // 更新开始时间格式
	changeStartTimeFormat(event) {
		let selectedDate = event.detail.value;
		if (selectedDate) {
      if (this.endTime && new Date(selectedDate).getTime() - new Date(this.endTime).getTime() > 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.start_time_not_lg_end_time'), true);
      } else {
        this.startTime = new Date(selectedDate).toISOString();
      }
		}
	}
  // 更新结束时间格式
	changeEndTimeFormat(event) {
		let selectedDate = event.detail.value;
		if (selectedDate) {
      if (this.startTime && new Date(selectedDate).getTime() - new Date(this.startTime).getTime() < 0) {
        this.appService.toastTip(this.translateService.instant('shared_components.filter_modals.end_time_not_lg_start_time'), true);
      } else {
        this.endTime = new Date(selectedDate).toISOString();
      }
		}
  }

  // 将查询到的code转化为下拉组件可以识别的形式
  getOptionList(list) {
    let options = [];
		list.forEach(item => {
      let lang = localStorage.getItem("APP_LANG");
      switch (lang) {
        case 'zh_CN':
          options.push({ text: item.code_desc_zh, value: item.code });
          break;
        case 'en_US':
          options.push({ text: item.code_desc_en, value: item.code });
          break;
        case 'zh_TW':
          options.push({ text: item.code_desc_tr, value: item.code });
          break;
        case 'vi':
          options.push({ text: item.code_desc_vi, value: item.code });
          break;
        case 'km':
          options.push({ text: item.code_desc_km, value: item.code });
          break;
        case 'th':
          options.push({ text: item.code_desc_th, value: item.code });
          break;
        case 'lo':
          options.push({ text: item.code_desc_lo, value: item.code });
          break;
        default:
          options.push({ text: item.code_desc_en, value: item.code });
          break;
      }
		});
		return options;
  }

  getTranslateCode(str) {
    let trans = '';
    if (str) {
      const codes = str.split(',');
      codes.forEach((code, index) => {
        trans += this.translateService.instant(code);
        if (index !== codes.length - 1) {
          trans += ',';
        }
      });
    }
    return trans;
  }

  // 翻译
  getTranslateCodeOfList(str, list) {
    let trans = '';
    if (str && list) {
      list.forEach(item => {
        if (item.code == str) {
          let lang = localStorage.getItem("APP_LANG");
          switch (lang) {
            case 'en_US':
              trans = item.code_desc_en;
              break;
            case 'zh_TW':
              trans = item.code_desc_tr;
              break;
            case 'vi':
              trans = item.code_desc_vi;
              break;
            case 'km':
              trans = item.code_desc_km;
              break;
            case 'th':
              trans = item.code_desc_th;
              break;
            case 'lo':
              trans = item.code_desc_lo;
              break;
            default:
              trans = item.code_desc_zh;
              break;
          }
        }
      });
    }
    return trans;
  }

  getStatusDisplay() {
    let statusList = [];
    if (this.isCompany) {
      statusList = this.contractorStatusList;
    } else if (this.isEmployee) {
      statusList = this.employeeStatusList;
    } else if (this.isProject) {
      statusList = this.projectStatusList;
    } else if (this.isWork) {
      statusList = this.workStatusList;
    } else if (this.isEval) {
      statusList = this.evalStatusList;
    }

    const translatedStatus = String(this.query.status)
      .split(',')
      .map(code => this.getTranslateCodeOfList(code, statusList))
      .filter(Boolean)
      .join(', ');
    return translatedStatus || this.query.status;
  }

  // 选择风险等级
  async selectRiskLevel() {
    let i = 0;
    if (this.query.level) {
      this.workRiskLevelList.forEach((res, index) =>{
        if (res.code === this.query.level) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.level = value.riskLevel.value;
          }
        }
      ],
      columns: [
        {
          name: 'riskLevel',
          options: this.getOptionList(this.workRiskLevelList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 选择职业/工种
  async selectOccupation() {
    let i = 0;
    if (this.query.occupation) {
      this.occupationList.forEach((res, index) =>{
        if (res.code === this.query.occupation) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.occupation = value.occupation.value;
          }
        }
      ],
      columns: [
        {
          name: 'shared_components.filter_modals.occupation',
          options: this.getOptionList(this.occupationList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 选择评级
  async selectReview() {
    let i = 0;
    if (this.query.reviewRate) {
      this.reviewList.forEach((res, index) =>{
        if (res.code === this.query.reviewRate) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.reviewRate = value.reviewRateObj.value;
          }
        }
      ],
      columns: [
        {
          name: 'reviewRateObj',
          options: this.getOptionList(this.reviewList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  private async openMultiStatusModal(statusList: any[]) {
    const lang = this.localStorageService.getStore('APP_LANG');
    let displayField = 'code_desc_zh';
    switch (lang) {
      case 'zh_CN': displayField = 'code_desc_zh'; break;
      case 'zh_TW': displayField = 'code_desc_tr'; break;
      case 'en_US': displayField = 'code_desc_en'; break;
      case 'vi': displayField = 'code_desc_vi'; break;
      case 'km': displayField = 'code_desc_km'; break;
      case 'th': displayField = 'code_desc_th'; break;
      case 'lo': displayField = 'code_desc_lo'; break;
      default: displayField = 'code_desc_zh'; break;
    }

    history.pushState(null, null, document.URL);
    const statusModal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.status'),
        placeholderMessage: this.translateService.instant('shared_components.common.status'),
        optionList: statusList,
        displayField: displayField,
        valueField: 'code',
        multiSelect: true,
        needFilterSearch: false,
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.status ? String(this.query.status).split(',') : [],
      },
      showBackdrop: true,
      backdropDismiss: true
    });

    statusModal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (Array.isArray(res.data)) {
        this.query.status = res.data.length > 0 ? res.data.join(',') : null;
      }
    });
    return await statusModal.present();
  }

  // 选择状态下拉
  async selectTaskStatus() {
    if (this.isCompany) {
      this.taskStatusList = this.contractorStatusList;
      if (this.isContractorCompanyMultiSelect) {
        return this.openMultiStatusModal(this.contractorStatusList);
      }
    } else if (this.isEmployee) {
      this.taskStatusList = this.employeeStatusList;
      if (this.isContractorEmployeeMultiSelect) {
        return this.openMultiStatusModal(this.employeeStatusList);
      }
    } else if (this.isProject) {
      this.taskStatusList = this.projectStatusList;
      if (this.isContractorProjectMultiSelect) {
        return this.openMultiStatusModal(this.projectStatusList);
      }
    } else if (this.isWork) {
      this.taskStatusList = this.workStatusList;
      if (this.isContractorWorkMultiSelect) {
        return this.openMultiStatusModal(this.workStatusList);
      }
    } else if (this.isEval) {
      this.taskStatusList = this.evalStatusList;
    }
    let i = 0;
    if (this.query.status) {
      this.taskStatusList.forEach((res, index) =>{
        if (res.code === this.query.status) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('common.cancel'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.status = value.taskStatus.value;
          }
        }
      ],
      columns: [
        {
          name: 'taskStatus',
          options: this.getOptionList(this.taskStatusList),
          selectedIndex: i
        }
      ]
    };
  
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 选择相关方公司
  async selectInterestedParty() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        originalOptionList: this.contractorCompanyList,
        displayField: ['name'],
        valueField: '$self',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.interestedPartyId
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.interestedPartyId = res.data;
      }
    });
    return await modal.present();
  }

  async selectInterestedPartyLazy() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: LazyLoadingSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.contractor_company'),
        originalOptionList: [],
        displayField: ['name'],
        valueField: '$self',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.interestedPartyId,
        isContractorOrg: true,
        // searchData: staffData,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.interestedPartyId = res.data;
      }
    });
    return await modal.present();
  }

  // 选择组织架构
  async selectOrg() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: OrgCascaderComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.common.organization_structure'),
        placeholderMessage: this.translateService.instant('shared_components.common.organization_structure'),
        selected: this.query.organization,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.organization = res.data;
      }
    });
    return await modal.present();
  }

  // 选择项目
  async selectProject() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.project_name'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.project_name'),
        originalOptionList: this.projectList,
        displayField: ['name'],
        valueField: '$self',
        multiSelect: false,
        format: '$1',
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query.projectId
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.projectId = res.data;
      }
    });
    return await modal.present();
  }

  // 选择地点
  async selectLocations() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: CorpSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.locations'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.locations'),
        originalOptionList: this.locationsList,
        selected: this.query.spaceId,
        showInvalid: true
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.spaceId = res.data;
      }
    });
    return await modal.present();
  }

  // 获取层级的地点名称
  getLocationLevelName(space) {
    let spaceName = '';
    if (space && this.locationsList) {
      const namesPath = this.findNodePathById(this.locationsList, space.id);
      spaceName = (namesPath && namesPath.length) > 0 ? namesPath.join(' / ') : '';
    }
    return spaceName;
  }
  findNodePathById(tree, targetId, names = []) {
    // 遍历当前层级的每个节点
    for (const node of tree) {
      // 将当前节点的名字添加到路径名称数组中
      names.push(node.spaceName);
      // 如果当前节点的ID匹配目标ID，则返回路径名称数组
      if (node.id === targetId) {
        return names;
      }
      // 如果当前节点有子节点，则递归查找子树
      if (node.childSpace && node.childSpace.length > 0) {
        // 递归调用，传递当前节点的子树、目标ID以及当前路径
        const foundNames = this.findNodePathById(node.childSpace, targetId, names.slice());
        // 如果在子树中找到了目标ID，则返回找到的名称路径，否则回溯
        if (foundNames) {
          return foundNames;
        }
      }
      // 当前节点不是目标节点且其子节点也没有找到目标ID，从路径中移除当前节点的名字，进行回溯
      names.pop();
    }
    // 如果遍历完当前层级仍未找到目标ID，则返回null
    return null;
  }
}
